/**
 * Global event bus
 *
 * Usage:
 *        app.Events.on('any_event', callback(data))
 *        app.Events.trigger('any_event', data)
 *
 * @author NikolaV
 */

const eventNamespace = 'globalbus';

export enum EventsGlobal {
    TREE_DATA_LOADED = 'tree-data-loaded',
    MAP_FIT_EXTENT = 'map-fit-extent',
    MAP_FIT_VISIBLE = 'map-fit-visible',
    MAP_FIT_PHOTOS = 'map-fit-photos',
    MAP_FIT_DOCUMENTS = 'map-fit-documents',
    MAP_OPEN_IMAGE_FOLDER_WITH_THUMBNAILS = 'map-open-image-folder-with-thumbnails',
    MAP_OPEN_DOCUMENTS_FOLDER_WITH_THUMBNAILS = 'map-open-documents-folder-with-thumbnails',
    GLOBAL_SEARCH_TOGGLE = 'global-search-toggle',
    MAIN_MENU_LOADED = 'main-menu-loaded',
    FLOATING_WINDOW_OPENED = 'floating-window-opened',
    FLOATING_WINDOW_CLOSED = 'floating-window-closed',
    MAP_MEASUREMENTS_LOADED = 'map-measurements-loaded',
    MAP_MEASUREMENT_SAVED = 'map-measurements-saved',
    PROJECT_CHANGE_BEFORE = 'project-change-before',
}

function on(event: string | EventsGlobal, callback: (eventObject: JQueryEventObject, ...args: any[]) => any) {
    $(window).on((event as any) + '.' + eventNamespace, callback);
}

function off(event: string | EventsGlobal, callback?: (eventObject: JQueryEventObject, ...args: any[]) => any) {
    if (!event) {
        $(window).off(eventNamespace);
    } else {
        $(window).off((event as any) + '.' + eventNamespace, callback);
    }
}

function trigger(event: string | EventsGlobal, data?: any) {
    $(window).trigger((event as any) + '.' + eventNamespace, data);
}

export const Events = {
    on,
    off,
    trigger,
};
